export default __webpack_public_path__ + "sounds/ba0157395ca34d11750540d8f4fda6a5.mp3";